export const IMG_ENDPOINT = 'https://img02.trgp.jp';
export const PUSH_SERVER_KEY = FCM_SERVER_KEY;
export const PUSH_PROJECT_ID = FCM_PROJECT_ID;
export const PUSH_SENDER_ID = FCM_SENDER_ID;


// WEBPACK FOOTER //
// ./src/environments/environment.ts